<template>
	<div class="search-product-tag">
		<div class="el-search vue-top-padding radius">
			<div class="el-left" style="margin: 0;">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['product:tag:insert']"
					icon="el-icon-plus"
					@click="addProductTag"
					style="margin: 0;"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="productTag"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="name" style="margin: 0 10px 0 0;">
						<el-input
							v-model="search.name"
							:placeholder="$t('searchProductTag.name')"
						></el-input>
					</el-form-item>
					<el-form-item style="margin: 0;">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('productTag')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchProductTag",
	props: {
		search: Object,
	},
	data() {
		return {};
	},
	methods: {
		addProductTag() {
			this.$emit("addProductTag");
		},
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style scoped></style>
